import React, { useState } from 'react'
import SkeletonLoader from 'src/components/common/skeletonLoading'
import { GridContainer, GridItem } from 'src/components/common/grids'
import { Button } from '@habitech/call-to-action'
import Icon from 'src/components/common/Icon'
import { NotesContainer } from './Notes.styles'
import { formatDate } from 'src/helpers/formatDate'
import ScoreUserInfo from '../ScoreUserInfo/ScoreUserInfo'

const Notes = ({ isUserRetention, loading, onChange, data }) => {
    const [value, setValue] = useState(data?.note_content || '');
    const [error, setError] = useState(false);

    const sendNote = () => {
        if (value.length > 500 || error) {
            setError(true);
            return;
        }
        onChange({ value, name: 'note_content', id: data?.id, ticket_id: data?.ticket_id, user_id: data?.user_id })
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter' && e.ctrlKey) {
            sendNote();
        }
    };

    const handleChange = (event) => {
        setValue(event.target.value);

        const shouldSetValue = event.target.value.length <= 500;

        if (shouldSetValue) {
            setError(false);
        } else {
            setError(true);
        }
    };

    if (loading && !data) return (
        <>
            <SkeletonLoader height='105px' />
            <GridContainer>
                <GridItem lg={8}>
                    <SkeletonLoader height='18px' />
                </GridItem>
                <GridItem lg={4}>
                    <SkeletonLoader height='18px' />
                </GridItem>
            </GridContainer>
            <SkeletonLoader height='18px' width='190px' />
        </>
    )

    if (isUserRetention) return <ScoreUserInfo {...{
        loading,
        data
    }} />;

    return (
        <NotesContainer noteError={error}>
            <textarea
                className='note-textarea'
                placeholder='Escribe una nota'
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                disabled={loading}
                data-testid='textarea'
            />
            {
                error && (
                    <small className='error-note'>
                        La nota no puede superar los 500 caracteres
                    </small>
                )
            }
            <div className="container-info-notes">
                <small className='last-date'>{
                    data?.note_updated_at
                    && `Última actualización: ${formatDate(data.note_updated_at, '', true)}`
                }
                </small>
                <small className='counter'>{value.length}/500</small>
            </div>
            <small className='note-by'>{
                data?.note_updated_by_fullname
                && `Actualizado por: ${data.note_updated_by_fullname}`
            }
            </small>
            <div className="container-buttons-notes">
                <Button
                    dataId="add-note"
                    originType="pcom"
                    variant='stroke'
                    disabled={error}
                    onClick={sendNote}
                    loading={loading}
                    dataTestId='add-note'
                >
                    <Icon disableFill icon='pcom-icon-circle-plus-outline' size={18} />
                    Agregar Nota
                </Button>
            </div>
        </NotesContainer>
    )
}

export default Notes